import { render, staticRenderFns } from "./IconRow.vue?vue&type=template&id=7a3e213e&"
import script from "./IconRow.vue?vue&type=script&lang=js&"
export * from "./IconRow.vue?vue&type=script&lang=js&"
import style0 from "./IconRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports